import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getThemeColors, THEME_OPTIONS } from '../theme'
import Header from './Header'
import Footer from './Footer'

const RESPONSABLE = 'acuneo / JobPipeline'
const CONTACTO = 'contacto@cuneo.pro'
const PRIVACY_VERSION = '2026-04-19'

export default function Privacidad({ theme = THEME_OPTIONS.LIGHT, session = null }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()
  const search = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null
  const fromBetaAccess = search?.get('from') === 'beta-access'
  const fromRegister = search?.get('from') === 'register'

  const sectionStyle = {
    background: C.white,
    border: `0.5px solid ${C.border}`,
    borderRadius: '18px',
    padding: '24px',
    boxShadow: C.shadow,
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, color: C.text, fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <Header theme={theme} session={session} perfil={null} />

      <div style={{ maxWidth: '1080px', margin: '0 auto', padding: 'clamp(16px, 3vw, 32px)', boxSizing: 'border-box' }}>
        <div style={{ ...sectionStyle, marginBottom: '18px' }}>
          <div style={{ fontSize: '11px', color: C.blue, textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: '600', marginBottom: '8px' }}>Privacidad</div>
          <div style={{ fontSize: '34px', fontWeight: '500', letterSpacing: '-1px', lineHeight: '1.1', marginBottom: '10px' }}>Aviso de Privacidad de JobPipeline</div>
          <div style={{ fontSize: '13px', color: C.muted, lineHeight: '1.8' }}>
            Responsable: {RESPONSABLE}<br />
            Contacto: {CONTACTO}<br />
            Última actualización: {PRIVACY_VERSION}
          </div>
        </div>

        <div style={{ display: 'grid', gap: '18px' }}>
          <div style={sectionStyle}>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>1. Datos que tratamos</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              Podemos tratar datos como correo electrónico, credenciales de acceso, nombre, CV, texto extraído del CV, preferencias de búsqueda, keywords, ubicación, seniority, historial de uso dentro de la plataforma, estatus de vacantes, eventos de producto y datos técnicos razonables de seguridad y operación.
            </div>
          </div>

          <div style={sectionStyle}>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>2. Finalidades</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              Usamos tus datos para crear y administrar tu cuenta, operar JobPipeline, analizar tu perfil profesional, buscar y priorizar oportunidades laborales, mostrarte resultados dentro del dashboard, mejorar el producto, mantener seguridad operativa, atender soporte, y enviarte comunicaciones relacionadas con la beta, el servicio y cambios relevantes.
            </div>
          </div>

          <div style={sectionStyle}>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>3. Datos sensibles</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              JobPipeline no solicita intencionalmente datos personales sensibles. Te pedimos evitar incluir información sensible innecesaria en tu CV o en cualquier texto que subas a la plataforma.
            </div>
          </div>

          <div style={sectionStyle}>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>4. Compartición y proveedores</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              Para operar el servicio podemos apoyarnos en proveedores de infraestructura, autenticación, base de datos, automatización y correo. Solo compartimos lo razonablemente necesario para operar JobPipeline, proteger la plataforma y prestar sus funciones.
            </div>
          </div>

          <div style={sectionStyle}>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>5. Derechos ARCO y contacto</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              Puedes solicitar acceso, rectificación, cancelación u oposición respecto de tus datos, así como pedir aclaraciones sobre su tratamiento, escribiendo a {CONTACTO}. Atenderemos solicitudes razonables conforme a la legislación aplicable y a las limitaciones técnicas y legales correspondientes.
            </div>
          </div>

          <div style={sectionStyle}>
            <div style={{ fontSize: '20px', fontWeight: '500', marginBottom: '10px' }}>6. Cambios al aviso</div>
            <div style={{ fontSize: '14px', color: C.muted, lineHeight: '1.9' }}>
              Podemos actualizar este aviso de privacidad para reflejar cambios del producto, de seguridad, de operación o legales. Cuando el cambio sea relevante, lo comunicaremos dentro de la plataforma o por correo y, si aplica, pediremos una nueva aceptación.
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '24px' }}>
          <button onClick={() => navigate(fromBetaAccess ? '/beta-access' : fromRegister ? '/login?mode=register' : (session ? '/dashboard' : '/'))} style={{ fontSize: '12px', color: C.blue, background: 'none', border: 'none', cursor: 'pointer' }}>
            {fromBetaAccess ? 'Volver a acceso beta' : fromRegister ? 'Volver al registro' : session ? 'Volver al dashboard' : 'Volver al inicio'}
          </button>
          <button onClick={() => navigate('/terminos')} style={{ fontSize: '12px', color: C.muted, background: 'none', border: 'none', cursor: 'pointer' }}>
            Terminos y Condiciones
          </button>
        </div>

        <Footer theme={theme} />
      </div>
    </div>
  )
}

